var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderReport = function SvgHeaderReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-253.535 -450.535) translate(253.535 450.535)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.307 0h10a2.307 2.307 0 0 1 2.307 2.307v10a2.307 2.307 0 0 1-2.314 2.3h-10A2.307 2.307 0 0 1 0 12.3v-10A2.307 2.307 0 0 1 2.307 0zm0 .769A1.538 1.538 0 0 0 .769 2.307v10a1.538 1.538 0 0 0 1.538 1.538h10a1.538 1.538 0 0 0 1.535-1.545v-10A1.538 1.538 0 0 0 12.3.769zM8.459 7.3a1.153 1.153 0 1 1-1.538-1.083V3.845a.769.769 0 0 1 .769-.769h3.076a.769.769 0 0 1 .769.769v6.921a.769.769 0 0 1-.769.769H3.845a.769.769 0 0 1-.769-.769V3.845a.769.769 0 0 1 .769-.769h1.538v.769H3.845v6.921h6.921V3.845H7.69v2.372a1.154 1.154 0 0 1 .769 1.088zM7.3 6.921a.384.384 0 1 0 .384.384.384.384 0 0 0-.384-.384z",
    transform: "translate(-253.535 -450.535) translate(257.845 454.845)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header-report.1cd1be5a.svg";
export { ForwardRef as ReactComponent };